import { useState, useEffect } from 'react'
import Select from 'react-select'
import classNames from 'classnames'
import { getHookInfo, isDisabled, makeInteger } from '../../utils'
import allHooks from '../../hooks/allHooks'
import { BEHAVIOR_TYPE, FORMAT_TYPE } from '../../constants'
import { Button } from 'reactstrap'
import { getSelectFieldChoices, calcMaxLength } from './AppObjectFieldUtils'
import PubSub from 'pubsub-js'

export default function AppObjectFieldSelect(props) {
  const { field, object, formInputs, parentObjectId, action, value, handleChange, hasChanged, inputAttribute } = props
  console.log(`AppObjectFieldSelect rendered: ${field.name}`, props)

  const [choicesRetrieved, setChoicesRetrieved] = useState(false)
  const [largeChoice, setLargeChoice] = useState(false)
  let hookInfo = null

  function largeChoiceHookCallback (selectedValue) {
    console.log('inside largeChoiceHookCallback', selectedValue)
    setLargeChoice(false)
    handleChange(selectedValue, hasChanged, field.id)
  }

  function localHandleChange(selectedValue) {
    if (formInputs[field.id].currentValue && selectedValue) {
      if (selectedValue.value !== formInputs[field.id].currentValue.id) {
        handleChange(selectedValue, hasChanged, field.id)
      }
    } else {
      if (!selectedValue) {
        selectedValue = { value: null, label: null }
      }
      handleChange(selectedValue, hasChanged, field.id)
    }
  }

  function handleDependsOnChangeEvent(msg, data) {
    console.log(`EVENT RECEIVED (AppObjectFieldSelect): ${field.name} recieved ${msg} to `, data)
    handleChange({ value: null, label: null }, hasChanged, field.id)
    setOptions([])
    setChoicesRetrieved(false)
  }

  // for fields that depend on other fields
  useEffect(() => {
    const tokens = []
    if (field.dependsOn) {
      for (let dependsOn of field.dependsOn) {
        tokens.push(PubSub.subscribe(`OBJECT: ${object.id} ${dependsOn.name} CHANGED`, handleDependsOnChangeEvent))
        return function cleanup() {
          for (let token of tokens) {
            PubSub.unsubscribe(token)
          }
        }
      }
    }
  })

  let selectedItem = null
  let initialOptions = []
  if (value && value.id) {
    selectedItem = { value: value.id, label: value.name }
    if (!choicesRetrieved) {
      initialOptions.push(selectedItem)
    }
  }
  const [options, setOptions] = useState(initialOptions)

  async function handleFocus() {
    console.log('AppObjectFieldSelect.handleFocus name: ', field.name, 'choiceType: ', field.choiceType, 'choiceValue: ', field.choiceValue, 'choicesRetrieved: ', choicesRetrieved)
    if (!choicesRetrieved) {
      const choiceValues = await getSelectFieldChoices(field, object, parentObjectId, formInputs)
      setChoicesRetrieved(true)
      setOptions(choiceValues)
    }
  }

  if (isDisabled(action, field.behaviorType)) {
    //console.log(`Field "${field.name}" is READ-ONLY`)
    let itemText = value.name
    
    //------------- FORMAT HOOK ---------------
    if (field.formatType && makeInteger(field.formatType.id) === FORMAT_TYPE.useHook) {
      hookInfo = getHookInfo(field.formatValue)
      let component = allHooks[hookInfo.moduleName][hookInfo.functionName](object, field, null, itemText)
      return component
    }
    //-----------------------------------------

    return <span>{itemText}</span>
  }

  const maxLength = calcMaxLength(options)
  const isClearable = (field.behaviorType.id === BEHAVIOR_TYPE.required) ? false : true

  // if choices retrieved, let cypress know with invisible div
  let retrievedIndicator = ''
  if (choicesRetrieved) {
    console.log('************************************** OPTIONS RETRIEVED **********************************************')
    retrievedIndicator = <div data-cy-options-retrieved={`field-${field.id}`}></div>
  }

  if (field.largeChoice === 'Y') {
    let currentSelection = null
    if (value && value.id) {
      currentSelection = <div>{value.name}</div>
    }
    let searchComponent = ''
    if (largeChoice) {
      console.log(window, field)
      const hookInfo = getHookInfo(field.largeChoiceHook)
      searchComponent = allHooks[hookInfo.moduleName][hookInfo.functionName](object.id, field, largeChoiceHookCallback, setLargeChoice)
    }
    console.log(searchComponent)
    return (
      <div>
        {currentSelection}
        <Button style={{marginTop: '5px'}} onClick={() => { setLargeChoice(true) }}>Click here to search for a {field.name}</Button>
        {searchComponent}
      </div>
    )
  } else {
    return (
      <div style={{ width: `${(5 * maxLength) + 150}px` }} data-cy={`field-${field.id}`}>
        <Select
          valid={inputAttribute === 'valid'}
          invalid={inputAttribute === 'invalid'}
          name={field.id}
          className={classNames('app-object-field-select', { 'invalid': inputAttribute === 'invalid' }, { 'valid': inputAttribute === 'valid' })}
          id={field.id}
          value={selectedItem}
          onChange={(event) => localHandleChange(event)}
          onFocus={handleFocus}
          isClearable={isClearable}
          options={options}
        />
        {retrievedIndicator}
      </div>
    )
  }
}
